var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConsentImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 12H13L10.5 8L8.43558 11.6183L6.81902 10L5 12ZM6.70336 7.52672C6.93111 7.52672 7.12406 7.45233 7.28221 7.30354C7.44035 7.15477 7.51943 6.97411 7.51943 6.76156C7.51943 6.54902 7.43971 6.36896 7.28028 6.22137C7.12086 6.07379 6.92726 6 6.6995 6C6.47175 6 6.2788 6.07439 6.12065 6.22318C5.96251 6.37195 5.88344 6.55261 5.88344 6.76516C5.88344 6.9777 5.96315 7.15776 6.12259 7.30534C6.28201 7.45293 6.4756 7.52672 6.70336 7.52672Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.25,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsentImage);
export default __webpack_public_path__ + "static/media/consent_image.80b9596405e6cd66ed4db33a56615222.svg";
export { ForwardRef as ReactComponent };